import { render } from "./TargetsList.vue?vue&type=template&id=04b7607e&bindings={\"cursor\":\"data\",\"limit\":\"data\",\"error\":\"data\",\"targetListItems\":\"data\",\"npages\":\"options\",\"category\":\"options\",\"date\":\"options\",\"editTarget\":\"options\",\"deleteTarget\":\"options\",\"loadPage\":\"options\",\"loadTargetsList\":\"options\",\"showErrorMessage\":\"options\"}"
import script from "./TargetsList.vue?vue&type=script&lang=js"
export * from "./TargetsList.vue?vue&type=script&lang=js"
script.render = render

export default script